import { AppIconButton } from "../../../../../shared/components/AppIconButton";
import { AppUnderlinedTitle } from "../../../../../shared/components/AppUnderlinedTitle";
import { PlusIcon } from "../../../../../shared/icons/PlusIcon";

interface Props {
  addNewPermissionBlock: () => void;
}

export const PermissionModalHeader = ({ addNewPermissionBlock }: Props) => {
  return (
    <AppUnderlinedTitle leftContent={"Настройки доступа"}>
      <AppIconButton onClick={addNewPermissionBlock}>
        <PlusIcon />
      </AppIconButton>
    </AppUnderlinedTitle>
  );
};
